import React, { useRef, useState, useEffect } from "react";
import { View, Modal, SafeAreaView } from "react-native";

import { Button } from "components";
import { colors, sizes } from "assets/constants";

import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";

interface WebImageCropperT {
  isVisible?: boolean;
  close?: () => void;
  image?: ImageUploaderT;
  onCrop: (uri?: string, size?: { width: number; height: number }) => void;
}

const WebImageCropper: React.FC<WebImageCropperT> = ({
  isVisible,
  close,
  image,
  onCrop,
}) => {
  const [cropSize, setCropSize] = useState({ width: 480, height: 640 });

  const cropperRef = useRef<ReactCropperElement>(null);

  const [croppedImg, setCroppedImg] = useState("");
  const onCropComplete = () => {
    const cropper = cropperRef.current?.cropper;

    setCroppedImg(cropper.getCroppedCanvas().toDataURL());
    setCropSize({
      width: cropper.getCroppedCanvas().width,
      height: cropper.getCroppedCanvas().height,
    });
  };

  const _onCheck = () => {
    onCrop(croppedImg, cropSize);
  };

  useEffect(() => {
    if (cropperRef.current && image) {
      setCroppedImg(
        cropperRef.current?.cropper?.getCroppedCanvas()?.toDataURL()
      );
    }
  }, [cropperRef.current, image]);

  return (
    <Modal visible={isVisible} onRequestClose={close} animationType="fade">
      <SafeAreaView style={{ flex: 1, backgroundColor: colors.black }}>
        <View
          style={{
            position: "absolute",
            top: 0,
            width: "100%",
            height: 65,
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingHorizontal: sizes.space,
            zIndex: 1000,
            backgroundColor: colors.black + "44",
          }}
        >
          <Button
            zIndex={1000}
            square={45}
            bgColor={colors.white}
            icon={{ name: "x", color: colors.danger }}
            onPress={close}
          />

          <Button
            zIndex={1000}
            square={45}
            bgColor={colors.white}
            icon={{ name: "check", color: colors.theme }}
            onPress={_onCheck}
          />
        </View>

        <Cropper
          src={image?.uri}
          style={{ height: "100%", width: "100%", background: "#000" }}
          // Cropper.js options
          initialAspectRatio={3 / 4}
          guides={false}
          ref={cropperRef}
          cropend={onCropComplete}
        />
      </SafeAreaView>
    </Modal>
  );
};

export default WebImageCropper;
